export enum LeagueDetailsComponentType {
  EDIT,
  COPY,
  ADD
}
